export default {
  grid: {
    quickLayout: 'クイックレイアウト',
    toolbar: {
      select: '選択',
      eraser: '消しゴム',
      selectAll: 'すべて選択',
      clear: 'クリア',
      reset: 'リセット',
    },
    board: {
      form: {
        number: {
          label: '行数',
          row: '行',
          col: '列',
        },
        type: {
          label: '配置形式',
          normal: '行列対齊',
          offset: '列のズレ',
          offsetY: '行のズレ',
        },
        background: {
          add: '背景の追加',
          label: '単一のグリッド画像',
          name: '一様なグリッドの背景',
          edit: '編集',
          change: '置き換え',
        },
      },
      boardTips:
        '注意：「グリッド」を再設計した場合は、「要素」画面に移動してレイアウトを再設計する必要があります',
      clickTips: 'クリック/ドラッグで必要なグリッドを選択できます',
    },
    chess: {
      name: '要素の削除',
      element: {
        title: '要素の選択',
        add: '要素の追加',
      },
      percent: {
        title: '',
        rule: '',
      },
      submit: 'ボードに適用',
    },
    tab: {
      board: 'グリッド',
      chess: '要素',
    },
  },
  dialog: {
    submit: '確認',
    cancel: 'キャンセル',
    select: {
      creatived: 'アクティブなマスを選択してください。',
      layout: '右側のパネル内で配置する要素を選択してください。',
    },
  },
}
